import { EmailClient } from '../../components/email-system/EmailClient';
import { Box, useTheme } from '@mui/material';
import Div100vh from 'react-div-100vh';
import Cookies from 'universal-cookie';

const EmailApp = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  // get background image
  const cookies = new Cookies();
  const storedBackgroundImageDark = cookies.get('backgroundImageDark')
    ? cookies.get('backgroundImageDark')
    : '/assets/uploads/background-dark.webp';
  const storedBackgroundImageLight = cookies.get('backgroundImageLight')
    ? cookies.get('backgroundImageLight')
    : '/assets/uploads/background-bright.webp';

  return (
    <Div100vh>
      <Box
        className="h-full w-full p-3"
        sx={{
          backgroundImage:
            mode === 'dark'
              ? 'url(' + storedBackgroundImageDark + ')'
              : 'url(' + storedBackgroundImageLight + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center bottom',
        }}
      >
        <EmailClient isStandalone />
      </Box>
    </Div100vh>
  );
};

export default EmailApp;
